import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminRepository } from 'repositories/AdminRepository';
import { IAdminGroupPoolConfigsState } from 'store/slices/adminGroupPoolConfigsSlice';
import { IAuthState } from 'store/slices/authSlice';
import { IGroupPoolConfig, TAdminGroupPoolConfigsQuery } from 'types';
import { EApiResponseStatus, IApiResponseDetails } from 'types/api';

export const fetchGroupPoolConfigs = createAsyncThunk<
  { content: IGroupPoolConfig[]; details: IApiResponseDetails },
  number,
  { state: { auth: IAuthState; adminGroupPoolConfigs: IAdminGroupPoolConfigsState } }
>('adminGroupPoolConfigs/fetchGroupPoolConfigs', async (deviceGroupId, { getState }) => {
  const {
    auth: { token },
    adminGroupPoolConfigs: { currentPage, itemsPerPage },
  } = getState();
  if (!token) throw Error('no token');

  const params: TAdminGroupPoolConfigsQuery = {
    page: String(currentPage),
    size: String(itemsPerPage),
    sort: 'pool_groups.priority,asc',
  };

  const adminGroupPoolConfigsResponse = await AdminRepository.getGroupPoolConfigs(
    token,
    deviceGroupId,
    params,
  );

  if (adminGroupPoolConfigsResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminGroupPoolConfigsResponse.error);
  }

  return adminGroupPoolConfigsResponse.data;
});

export const fetchGroupPoolConfigsAll = createAsyncThunk<
    { content: IGroupPoolConfig[]; details: IApiResponseDetails },
    void,
    { state: { auth: IAuthState; adminGroupPoolConfigs: IAdminGroupPoolConfigsState } }
>('adminGroupPoolConfigs/fetchGroupPoolConfigsAll', async (deviceGroupId, { getState }) => {
  const {
    auth: { token },
  } = getState();
  if (!token) throw Error('no token');

  const adminGroupPoolConfigsResponse = await AdminRepository.getAllPoolConfigs(
      token,
  );

  if (adminGroupPoolConfigsResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminGroupPoolConfigsResponse.error);
  }

  return adminGroupPoolConfigsResponse.data;
});